module.exports = __webpack_public_path__ + "img/banner-company-old.0c0c9028.jpg";